import { IS_PRODUCTION } from "@gameApp/constants";
import { gaExists } from "@gameApp/helpers/ga/exists";

export function gaPageView(path: string): void {
  if (gaExists(window)) {
    window.gtag("event", "page_view", {
      page_path: path,
      event_callback: () => {
        if (!IS_PRODUCTION) {
          console.debug("Page view sent", { path });
        }
      },
    });
  }
}
